import React, { Fragment, useEffect, useRef, useState } from "react";
import { dateFormation, isEmpty } from "../../common/cores";
import { maskAllButLast } from "../../utils/utils";

const OneRowTablePicker = ({ data, interval = 2000, speed = 400 }) => {
  const [index, setIndex] = useState(0);
  const tableRef = useRef(null);
  const [showPicker, setShowPicker] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % data.length);
    }, interval);

    return () => clearInterval(timer);
  }, [data.length, interval]);

  useEffect(() => {
    if (tableRef && tableRef.current) {
      const row = tableRef.current.querySelector("tr");
      const rowHeight = row ? row.offsetHeight : 0;
      tableRef.current.style.transform = `translateY(-${index * rowHeight}px)`;
      tableRef.current.style.transition = `transform ${speed}ms ease-in-out`;
    }
  }, [index, speed]);

  if (!showPicker) {
    return <Fragment></Fragment>;
  }
  return (
    <div
      className="ticker-wrapper"
      style={{
        overflow: "hidden",
        position: "fixed",
        zIndex: 100,
        background: "#222",
        bottom: 60,
        width: "100%",
        height: 35,
        borderTop: "1px solid rgb(136 136 136)",
      }}
    >
      <table
        ref={tableRef}
        style={{
          margin: 0,
          padding: 0,
          position: "relative",
          width: "100%",
        }}
      >
        <tbody>
          {data.map((list, index) => (
            <tr
              key={index}
              className=""
              style={{
                height: "35px",
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              <td align="center" width="30%">
                <p
                  style={{
                    color: "#fdd902",
                    fontSize: 14,
                    fontWeight: "bolder",
                  }}
                >
                  {list.type == -1
                    ? isEmpty(window.lang["실시간 출금 현황"])
                      ? "실시간 출금 현황"
                      : window.lang["실시간 출금 현황"]
                    : isEmpty(window.lang["실시간 입금 현황"])
                    ? "실시간 입금 현황"
                    : window.lang["실시간 입금 현황"]}
                </p>
              </td>
              <td align="center" style={{ paddingLeft: "5px" }}>
                <span style={{ color: "#999", fontSize: 14 }}>
                  {dateFormation(list.created_date, 11)}
                </span>{" "}
              </td>
              <td align="center" style={{ paddingRight: "5px" }}>
                <span style={{ color: "#999", fontSize: 14 }}>
                  {maskAllButLast(list.userid)}
                </span>
              </td>
              <td align="center" style={{ paddingRight: "5px" }}>
                <span style={{ color: "#999", fontSize: 14 }}>
                  {Number(list.amount).toLocaleString()}원
                </span>
              </td>
              <td align="center" width="50px">
                <i
                  className="fa fa-close"
                  style={{ fontSize: 20, color: "#999" }}
                  onClick={() => setShowPicker(!showPicker)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OneRowTablePicker;



// WEBPACK FOOTER //
// ./src/containers/Sports/OneRowTablePicker.js